/**
 * Ghanaian cedi.
 */
export var GHS = {
  code: 'GHS',
  base: 10,
  exponent: 2
};